import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../../common/api/apiShared";
import { Result } from "../../../common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IDeleteBusinessAreaDialog } from "./DeleteBusinessAreaDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function DeleteBusinessAreaDialogDataMapping(props: IDeleteBusinessAreaDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeBusinessArea = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<string>) => {
                props.onCloseDialog();

                if (response.success()) {
                    props.onDeletion();
                    snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: props.selectedBusinessArea.name } }));
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "businessAreaNotDeleted", values: { name: props.selectedBusinessArea.name } }), "warning");
                }
            },
        });
    };

    async function remove() {
        return await deleteHttp<string>(`/businessareas/${props.selectedBusinessArea.id}`);
    }

    return {
        removePurpose: removeBusinessArea,
        inProgess: removeMutation.isLoading,
    };
}
